/** Resolve a positive session duration in seconds when the API omits or zeroes duration_seconds. */
export function resolveSessionDurationSeconds(session: {
  duration_seconds?: number | null;
  started_at?: string | null;
  ended_at?: string | null;
  created_at?: string | null;
}): number | null {
  const raw = session.duration_seconds;
  if (raw != null && Number.isFinite(Number(raw)) && Number(raw) > 0) {
    return Number(raw);
  }
  const startIso = session.started_at || session.created_at;
  const endIso = session.ended_at;
  if (!startIso || !endIso) return null;
  const startMs = new Date(startIso).getTime();
  const endMs = new Date(endIso).getTime();
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return null;
  return Math.max(1, Math.round((endMs - startMs) / 1000));
}

export function formatSessionDurationLabel(seconds: number | null | undefined): string | null {
  if (seconds == null || !Number.isFinite(Number(seconds)) || Number(seconds) <= 0) return null;
  const total = Math.floor(Number(seconds));
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  if (minutes <= 0) return `${secs}s`;
  return `${minutes}m ${secs}s`;
}
